module.exports = __webpack_public_path__ + "img/surfer3.d7345fe9.svg";